export default __webpack_public_path__ + "static/media/render.8ba1bf3d.gif";